<template>
    <van-popup
        v-if="workOrderUserRevokePopupShow"
        :value="workOrderUserRevokePopupShow"
        z-index="100"
        :close-on-click-overlay="false"
        :style="{ height: '100vh', width: '100vw', background: 'rgba(0,0,0,.3)' }"
        overlay-class="custom_popup"
        position="right"
    >
        <div class="public_container add_approval_wrap">
            <div class="returnNavBar">
                <ReturnNavBar
                    title="返回"
                    :isCustomReturnEvent="true"
                    :isTitleNormal="true"
                    :isAllFunctions="true"
                    @returnEvent="handleClickClose"
                ></ReturnNavBar>
            </div>
            <div class="work_order_add_container mobile_container custom_mobile_form" v-loading="loading">
                <van-form
                    label-width="9.5em"
                    input-align="right"
                    scroll-to-error
                    :show-error-message="false"
                    :rules="workOrderProcessingUserRevokeFormRules"
                    ref="workOrderProcessingUserRevokeForm"
                    class=""
                >
                    <van-field
                        v-model="workOrderProcessingUserRevokeForm.processing_uids_text"
                        name="processing_uids"
                        label="撤回实施人员"
                        placeholder="请选择"
                        error-message-align="right"
                        is-link
                        readonly
                        @click="handleClickProcessingUidsFieldlink"
                    >
                    </van-field>
                </van-form>
            </div>
            <div class="add_footer_wrap mobile_add_footer_wrap">
                <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm"
                    >确定</van-button
                >
            </div>
            <!-- 实施人员选择 -->
            <UserSelect
                :userSelectVisible.sync="userSelectVisible"
                :userSelectTitle="'选择实施人员'"
                :selectType="'multiple'"
                :allUserList="processingUserSelectedList"
                @selectUserData="handleSelectUserData"
                v-if="userSelectVisible"
            />
        </div>
    </van-popup>
</template>
<script>
import { revokeProcessing } from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import UserSelect from "./component/user_select.vue";
export default {
    name: "WorkOrderProcessingUserRevoke",
    components: { ReturnNavBar, UserSelect },
    props: {
        workOrderUserRevokePopupShow: {
            type: Boolean,
            default: false,
        },
        workorder_id: "",
        processingUserSelectedList: {
            type: Array,
            default: () => [],
        }, // 现在已经分配的实施人员数据
    },
    data() {
        return {
            loading: false,
            workOrderProcessingUserRevokeForm: {
                processing_uids: "",
                processing_uids_text: "",
            },
            workOrderProcessingUserRevokeFormRules: {},
            userSelectVisible: false,

            btnDisabled: false,
        };
    },
    created() {},
    methods: {
        handleClickClose() {
            this.$emit("update:workOrderUserRevokePopupShow", false);
        },
        handleClickProcessingUidsFieldlink() {
            this.userSelectVisible = true;
        },
        // 选择实施人员确认
        handleSelectUserData(data) {
            this.$set(
                this.workOrderProcessingUserRevokeForm,
                "processing_uids",
                data.map((item) => item.id)
            );
            this.$set(
                this.workOrderProcessingUserRevokeForm,
                "processing_uids_text",
                data.map((item) => item.name).join()
            );
        },
        handleClickConfirm() {
            this.$refs.workOrderProcessingUserRevokeForm.validate().then(() => {
                if (!this.workOrderProcessingUserRevokeForm.processing_uids.length) return;
                const params = {
                    workorder_id: this.workorder_id,
                    processing_uids: this.workOrderProcessingUserRevokeForm.processing_uids,
                };
                this.btnDisabled = true;
                revokeProcessing(params)
                    .then((res) => {
                        if (res.code === 200) {
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.btnDisabled = false;
                                    this.$emit("update:workOrderUserRevokePopupShow", false);
                                    this.$emit("revokeSuccess");
                                },
                            });
                        } else {
                            this.btnDisabled = false;
                        }
                    })
                    .catch(() => {
                        this.btnDisabled = false;
                    });
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.mobile_container {
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;
}
</style>
